module.exports = __webpack_public_path__ + "static/MoneyAge-Mortgage-Awards-Image-3df58d7fd275db79585737628024621c.jpg";